function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { putProgramTaskApi, getProgramTaskInfoApi, getDynamicTaskApi, deleteProgramTaskApi, getProgramVersionApi, setProgramVersionApi } from '@/api/program';
import imageViewer from '@/components/common/imageViewer';
import draggable from 'vuedraggable';
import ClipboardJS from 'clipboard';
import SettingMer from '@/libs/settingMer';
import ueditorFrom from '@/components/form-common/oa-wangeditor';
export default {
  name: 'addProgram',
  components: {
    comment: function comment() {
      return import('../components/comment');
    },
    ueditorFrom: ueditorFrom,
    draggable: draggable,
    imageViewer: imageViewer
  },
  props: {
    projectList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    programVersionList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    programOptions: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    programMemberOptions: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      drawer: false,
      id: 0,
      principal: [],
      type: 0,
      memberShow: false,
      onlyOne: false,
      edit: false,
      dialogVisible: false,
      inputs: [{
        id: '',
        name: ''
      }],
      dragging: false,
      timeVal: [],
      formData: {
        status: 1,
        parent: {
          name: ''
        },
        uid: ''
      },
      priorityOptions: [{
        value: 1,
        label: '紧急'
      }, {
        value: 2,
        label: '高'
      }, {
        value: 3,
        label: '中'
      }, {
        value: 4,
        label: '低'
      }, {
        value: 0,
        label: '无优先级'
      }],
      statusOptions: [{
        value: 0,
        label: '未处理'
      }, {
        value: 1,
        label: '进行中'
      }, {
        value: 2,
        label: '已解决'
      }, {
        value: 3,
        label: '已验收'
      }, {
        value: 4,
        label: '已拒绝'
      }, {
        value: 5,
        label: '已关闭'
      }],
      rule: {
        name: [{
          required: true,
          message: '请输入项目名称',
          trigger: 'blur'
        }],
        program_id: [{
          required: true,
          message: '请选择关联项目',
          trigger: 'change'
        }]
      },
      nameShow: false,
      adminsShow: false,
      membersShow: false,
      priorityShow: false,
      timeValShow: false,
      pathShow: false,
      programShow: false,
      versionShow: false,
      describeShow: false,
      activeName: 'reply',
      dynamicTaskList: [],
      dynamicTotalCount: 0,
      totalCount: 0,
      srcList: []
    };
  },
  computed: {
    // 是否有操作权限
    isOperable: function isOperable() {
      return this.formData.operate;
    }
  },
  methods: {
    handleToggle: function handleToggle(showProperty) {
      if (!this.formData.operate) {
        return this.$message('没有操作权限');
      }
      this[showProperty] = true;
    },
    //预览图片
    previewPicture: function previewPicture(e) {
      if (e.target.tagName == 'IMG') {
        this.srcList = [e.target.src];
        this.$refs.imageViewer.openImageViewer(e.target.src);
      }
    },
    identAddress: function identAddress() {
      var type = 'type',
        relation_id = 'relation_id',
        program_id = 'program_id';
      return "".concat(SettingMer.httpUrl).concat(window.location.pathname).concat(window.location.search, "?&").concat(type, "=2&").concat(relation_id, "=").concat(this.id, "&").concat(program_id, "=").concat(this.formData.ident);
    },
    // 设置版本
    setVersion: function setVersion() {
      this.dialogVisible = true;
      this.getVersion();
    },
    submitVersion: function submitVersion() {
      var _this = this;
      setProgramVersionApi(this.formData.program_id, {
        data: this.inputs
      }).then(function () {
        _this.dialogVisible = false;
        _this.inputs = [];
        _this.$emit('getProgramVersionList', _this.formData.program_id);
      });
    },
    // 获取版本
    getVersion: function getVersion() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var result;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return getProgramVersionApi({
                program_id: _this2.formData.program_id
              });
            case 2:
              result = _context.sent;
              _this2.inputs = result.data;
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    handleCloseVersion: function handleCloseVersion() {
      this.dialogVisible = false;
      this.inputs = [];
    },
    addInput: function addInput() {
      this.inputs.push({
        id: '',
        name: ''
      });
    },
    removeInput: function removeInput(index) {
      this.inputs.splice(index, 1);
    },
    // 选择项目
    handleContract: function handleContract(eid) {
      this.$emit('getProgramVersionList', eid);
      this.$emit('getMemberList', eid);
      this.$emit('getProgramSelectList', eid);
      this.formData.version_id = '';
      this.formData.members = [];
      this.formData.uid = '';
      this.versionShow = true;
      this.programShow = false;
      this.putProgramTask('program_id', this.formData.program_id);
    },
    // 修改版本
    handleVersion: function handleVersion(e) {
      this.versionShow = false;
      this.putProgramTask('version_id', this.formData.version_id);
    },
    // 选择成员回调
    // getSelectList(data) {
    //   this.formData.uid = data[0].value
    //   this.principal = data
    //   this.formData.admins = data
    //   this.adminsShow = false
    //   this.putProgramTask('uid', this.formData.uid)
    // },
    // 获取任务详情
    getProgramInfo: function getProgramInfo(id) {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var result, membersId;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return getProgramTaskInfoApi(id);
            case 2:
              result = _context2.sent;
              membersId = [];
              result.data.members.map(function (item) {
                membersId.push(item.id);
              });
              _this3.$set(result.data, 'membersId', membersId);
              _this3.formData = result.data;
              _this3.principal = result.data.admins;
              _this3.formData.uid = result.data.uid !== 0 ? _this3.formData.uid : null;
              _this3.timeVal = _this3.formData.plan_start ? [_this3.formData.plan_start, _this3.formData.plan_end] : [];
              _this3.formData.priority = result.data.priority ? result.data.priority : 0;
              _this3.formData.version_id = result.data.version_id ? result.data.version_id : null;
              _this3.$emit('getProgramVersionList', result.data.program_id);
            case 13:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    // 删除标签
    cardTag: function cardTag(index) {
      this.principal.splice(index, 1);
      this.formData.uid = '';
    },
    onchangeTime: function onchangeTime(e) {
      if (e == null) {
        this.timeVal = '';
        this.formData.plan_start = '';
        this.formData.plan_end = '';
      } else {
        this.formData.plan_start = this.timeVal[0] || '';
        this.formData.plan_end = this.timeVal[1] || '';
      }
      this.timeValShow = false;
      this.putProgramTask('plan_date', this.formData.plan_start, this.formData.plan_end);
    },
    handleRemove: function handleRemove(e) {
      this.formData.path = e;
      this.formData.pid = e[e.length - 1];
      this.putProgramTask('pid', this.formData.pid);
      this.pathShow = false;
    },
    ueditorEdit: function ueditorEdit(e) {
      this.formData.describe = e;
    },
    openBox: function openBox(id) {
      this.drawer = true;
      this.edit = id ? true : false;
      this.id = id ? id : 0;
      if (this.edit) {
        this.getProgramInfo(id);
        this.getDynamicTask();
        // this.$refs.comment.getTaskComment()
      }
    },
    reset: function reset() {
      this.formData = {
        name: '',
        uid: '',
        pid: 0,
        path: [],
        program_id: null,
        version_id: null,
        members: [],
        plan_start: '',
        plan_end: '',
        status: null,
        priority: 0,
        describe: ''
      };
      this.timeVal = [];
      this.edit = false;
      this.principal = [];
    },
    // 新建子任务
    addSubtasks: function addSubtasks(data) {
      this.formData = {};
      this.formData.path = data.pid ? [data.pid].concat([data.id]) : data.id;
      this.formData.pid = data.id;
      this.formData.program_id = data.program_id;
      this.$emit('getProgramSelectList', data.program_id);
      this.$emit('openTask', this.formData, 1);
      this.drawer = false;
    },
    // 复制工作项
    copyTask: function copyTask() {
      this.$emit('openTask', this.formData, 2);
    },
    // 评论总条数
    gettotalCount: function gettotalCount(total) {
      this.totalCount = total;
    },
    // 删除
    deleteTask: function deleteTask() {
      var _this4 = this;
      this.$modalSure('删除任务，关联的子级任务均会被删除').then(function () {
        deleteProgramTaskApi(_this4.id).then(function () {
          _this4.drawer = false;
          _this4.reset();
          _this4.$refs.formData.resetFields();
          _this4.$emit('getTableData');
        });
      });
    },
    handleName: function handleName() {
      if (this.formData.name.trim()) {
        this.nameShow = false;
        this.putProgramTask('name', this.formData.name);
      } else {
        this.$message('任务名称不能为空');
      }
    },
    changeMembers: function changeMembers() {
      var _this5 = this;
      var conditions = [{
        show: this.membersShow,
        key: 'members',
        value: this.formData.membersId
      }, {
        show: this.adminsShow,
        key: 'uid',
        value: this.formData.uid
      }, {
        show: this.programShow,
        key: 'program_id',
        value: this.formData.program_id
      }, {
        show: this.timeValShow,
        key: 'plan_date',
        value: [this.formData.plan_start, this.formData.plan_end]
      }, {
        show: this.pathShow,
        key: 'pid',
        value: this.formData.pid
      }, {
        show: this.priorityShow,
        key: 'priority',
        value: this.formData.priority
      }, {
        show: this.versionShow,
        key: 'version_id',
        value: this.formData.version_id
      }];
      var promises = conditions.filter(function (condition) {
        return condition.show;
      }).map(function (condition) {
        return new Promise(function (resolve) {
          setTimeout(function () {
            _this5.putProgramTask(condition.key, condition.value);
            resolve();
          }, 500);
        });
      });
      Promise.all(promises).then(function () {
        _this5.membersShow = false;
        _this5.adminsShow = false;
        _this5.programShow = false;
        // this.timeValShow = false
        _this5.priorityShow = false;
        _this5.versionShow = false;
      });
    },
    selectAdmins: function selectAdmins() {
      this.putProgramTask('uid', this.formData.uid);
      this.adminsShow = false;
    },
    changePriority: function changePriority() {
      this.priorityShow = false;
      this.putProgramTask('priority', this.formData.priority);
    },
    getVal: function getVal() {
      var _this6 = this;
      var data = this.priorityOptions.find(function (option) {
        return option.value === _this6.formData.priority;
      });
      if (data) return data.label;
    },
    getProgramVal: function getProgramVal() {
      var _this7 = this;
      var data = this.projectList.find(function (option) {
        return option.value === _this7.formData.program_id;
      });
      if (data) return data.label;
    },
    getVersionVal: function getVersionVal() {
      var _this8 = this;
      var data = this.programVersionList.find(function (option) {
        return option.id === _this8.formData.version_id;
      });
      if (data) return data.name;
    },
    getClass: function getClass() {
      var type = this.formData.priority;
      switch (type) {
        case 0:
          {
            return 'info';
          }
        case 1:
          {
            return 'danger';
          }
        case 2:
          {
            return 'warning';
          }
        case 3:
          {
            return 'default';
          }
        case 4:
          {
            return 'success';
          }
        default:
          'info';
      }
    },
    // 保存富文本
    submitDescribe: function submitDescribe() {
      this.putProgramTask('describe', this.formData.describe);
    },
    // 修改任务
    putProgramTask: function putProgramTask(field, data, endTime) {
      var _this9 = this;
      var datas = {};
      datas['field'] = field;
      if (field == 'plan_date') {
        datas['plan_start'] = data || '';
        datas['plan_end'] = endTime || '';
      } else {
        datas[field] = data;
      }
      if (field == 'program_id') {
        if (!datas[field]) return;
      }
      if (field == 'plan_date' && datas.plan_end == '') {
        datas.plan_start = '';
      }
      putProgramTaskApi(this.id, datas).then(function () {
        _this9.describeShow = false;
        _this9.getProgramInfo(_this9.id);
      });
    },
    // 修改状态
    changeStatus: function changeStatus(e) {
      this.putProgramTask('status', e);
    },
    // 取消
    cancelDescribe: function cancelDescribe() {
      this.describeShow = false;
      this.getProgramInfo(this.id);
    },
    // 操作日志列表
    getDynamicTask: function getDynamicTask() {
      var _this10 = this;
      getDynamicTaskApi({
        relation_id: this.id
      }).then(function (res) {
        _this10.dynamicTaskList = res.data.list;
        _this10.dynamicTotalCount = res.data.total_count > 100 ? '99+' : res.data.total_count;
      });
    },
    // 关闭抽屉
    handleClose: function handleClose() {
      var _this11 = this;
      this.drawer = false;
      var properties = ['nameShow', 'adminsShow', 'membersShow', 'priorityShow', 'timeValShow', 'pathShow', 'programShow', 'versionShow', 'describeShow'];
      properties.forEach(function (property) {
        _this11.$set(_this11, property, false);
      });
      this.$emit('getTableData');
    },
    iconHadler: function iconHadler(_ref) {
      var row = _ref.row;
      if (!row.describe || row.describe.length == 0) {
        return 'icon-no';
      }
    },
    copy: function copy() {
      var _this12 = this;
      this.$nextTick(function () {
        var clipboard = new ClipboardJS('.copy');
        clipboard.on('success', function () {
          _this12.$message.success(_this12.$t('setting.copytitle'));
          clipboard.destroy();
        });
        _this12.$store.commit('app/SET_CLICK_TAB', false);
      });
    }
  }
};